import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';
import { useSignup } from '../../../contexts/SignupContext';

const SignupPanUpload = () => {
  const navigate = useNavigate();
  const { updateSignupState } = useSignup();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!file) {
      toast.error('Please select a PAN image to upload');
      return;
    }

    setLoading(true);

    updateSignupState({
      panUploadUrl: file.name,
    });

    toast.success('PAN uploaded successfully');
    navigate('/signup/aadhaar');
    setLoading(false);
  };

  return (
    <AuthLayout
      title="Upload PAN"
      subtitle="Upload a clear image of your PAN card to proceed"
      onBack={() => navigate('/signup/pan')}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">PAN Image</label>
          <input
            type="file"
            accept="image/*"
            className="form-input"
            onChange={(event) => setFile(event.target.files?.[0] || null)}
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Uploading...' : 'Upload & Continue'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default SignupPanUpload;


